import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  IconButton,
  Divider,
  TextField,
  Autocomplete,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GridViewIcon from "@mui/icons-material/GridView";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ImageIcon from "@mui/icons-material/Image";
//import AddIcon from "@mui/icons-material/Add";
//import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

const buttonStyle = {
  width: 0,
  background: "#f8f9fa",
  border: "3px solid #b0bec5",
  color: "black",
  fontSize: "0.850rem",
  "&:hover": { background: "#eceff1" },
  fontFamily: "Inter, sans-serif",
};
const sectionStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginBottom: 2,
  boxShadow: "0px 4px 8px rgba(0, 0, 1, 0.1)",
  fontFamily: "Inter, sans-serif",
};

export default function LandingPageBanner() {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [formValues, setFormValues] = useState({
    image_alt_text: "",
    title: "",
    subheading: "",
    cta_text: "",
    banner_image: "",
    link_page: "",
    collection_name: "",
  });
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [editingImageUrl, setEditingImageUrl] = useState("");
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [banners, setBanners] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [collectionOptions, setCollectionOptions] = useState([]);

  const handleBannerSubmit = async () => {
    let bannerReqData = {
      'id': formValues.id ? formValues.id : "",
      'image_alt_text': formValues.image_alt_text ? formValues.image_alt_text : "",
      'title': formValues.title ? formValues.title : "",
      'subheading': formValues.subheading ? formValues.subheading : "",
      'cta_text': formValues.cta_text ? formValues.cta_text : "",
      'link_page': formValues.link_page ? formValues.link_page : "",
      'collection_name': formValues.collection_name ? formValues.collection_name : "",
    };

    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    if (formValues.banner_image_file) {
      bannerReqData.banner_image = await convertToBase64(
        formValues.banner_image_file
      );
    } else if (isEditing && editingImageUrl) {
      bannerReqData.banner_image = editingImageUrl;
    }

    console.log(bannerReqData);

    try {
      let bannerResData = await postData(
        "/api/theme/landing_banner",
        bannerReqData
      );
      if (bannerResData["data"]["code"] === "200") {
        alert("Banner saved successfully.");
        if (isEditing) {
          setBanners(
            banners.map((banner) =>
              banner.id === selectedBanner.id ? formValues : banner
            )
          );
        } else {
          const newBanner = { ...formValues, id: banners.length + 1 };
          setBanners([...banners, newBanner]);
        }
        setIsFormVisible(false);
      } else {
        alert("Error saving banner. Please try again.");
      }
    } catch (error) {
      console.error("Error saving banner:", error);
    }
  };

  useEffect(() => {
    async function fetchBannerData() {
      let resData = await getData("/api/theme/landing_banner?is_admin=true");
      console.log(resData);
      let banners_data = resData["data"]["banners"];
      if (banners_data) {
        // Ensure collection and collection_url values are properly set
        const updatedBanners = banners_data.map((banner) => ({
          ...banner,
          collection: banner.collection || "", // Set collection ID or empty string
          collection_url: banner.collection_url || "", // Set collection_url or empty string
        }));
        setBanners(updatedBanners);
      } else {
        console.error("Error fetching banner data:", resData.message);
      }

      let collectionResData = await getData("/api/product/product-collection");
      console.log(collectionResData);
      let collections_data = collectionResData["data"]["live_collections"];
      if (collections_data) {
        const formattedCollections = collections_data.map((collection) => ({
          label: collection.collection || "",
          value: collection.id || "",
          collection_url: collection.collection_url || "",
        }));
        setCollectionOptions(formattedCollections);
      } else {
        console.error(
          "Error fetching collection data:",
          collectionResData.message
        );
      }

      setLoading(false);
    }

    fetchBannerData();
  }, []);

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    // Reorder banners
    const reorderedBanners = [...banners];
    const [removed] = reorderedBanners.splice(result.source.index, 1);
    reorderedBanners.splice(result.destination.index, 0, removed);

    // Update orientation_number for each banner
    const updatedBanners = reorderedBanners.map((banner, index) => ({
      ...banner,
      orientation_number: index + 1, // Update orientation_number based on new order
    }));

    // Prepare data for API submission
    const bannerReqData = {
      bannerOrder: updatedBanners.map((banner) => ({
        'id': banner.id,
        'orientation_number': banner.orientation_number,
      })),
    };

    try {
      const bannerResData = await postData(
        "/api/theme/landing_banner?is_admin = true",
        bannerReqData
      );

      if (bannerResData["data"]["code"] === "200") {
        alert("Banner order updated successfully.");
        // Update the state with the server response or reordered banners
        const serverUpdatedBanners =
          bannerResData.data.banners || updatedBanners;
        setBanners(serverUpdatedBanners.filter((banner) => banner.id)); // Ensure no empty objects are added
      } else {
        alert("Error updating banner order. Please try again.");
      }
    } catch (error) {
      console.error("Error updating banner order:", error);
    }
  };

  const handleVisibilityToggle = async (id, newStatus) => {
    // Prepare request payload
    const visibilityReqData = {
      id, // Pass the banner ID
      status: newStatus ? "enabled" : "disabled", // Update the status
    };

    try {
      // Post request to update the banner status
      let visibilityResData = await postData(
        "/api/theme/landing_banner?is_admin = true",
        visibilityReqData
      );

      // Handle response
      if (visibilityResData["data"]["code"] === "200") {
        alert("Banner visibility updated successfully.");
        setBanners((prevBanners) =>
          prevBanners.map((banner) =>
            banner.id === id
              ? { ...banner, status: visibilityReqData.status }
              : banner
          )
        );
      } else {
        alert("Error updating banner visibility. Please try again.");
      }
    } catch (error) {
      console.error("Error updating banner visibility:", error);
    }
  };

  /* const handleAddNewBanner = (image) => {
        setFormValues({ altText: '', title: '', subheading: '', ctaText: '', collection: '', url: '', banner_image: '' });
        setSelectedBanner(image);
        setIsFormVisible(true);
        setIsEditing(true);
    }; */

  const handleEditImage = (image) => {
    setFormValues(image);
    setSelectedBanner(image);
    setIsFormVisible(true);
    setIsEditing(true);
  };

  const handleDeleteImage = (id) => {
    setImages(images.filter((image) => image.id !== id));
  };

  const handleFormChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const img = new window.Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width === 1100 && img.height === 500) {
          // Revoke previous object URL if it exists
          if (
            formValues.banner_image &&-
            formValues.banner_image.startsWith("blob:")
          ) {
            URL.revokeObjectURL(formValues.banner_image);
          }
          setFormValues((prevState) => ({
            ...prevState,
            banner_image: imageUrl, // Store the object URL for preview
            banner_image_file: file, // Store the file object
          }));
          // Reset the file input value so the same file can be uploaded again
          event.target.value = "";
        } else {
          URL.revokeObjectURL(imageUrl); // Clean up if not valid
          alert("Image must be 1440px wide and 300px tall or smaller.");
        }
      };
    }
  };

  return (
    <Accordion sx={sectionStyle}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton color="" component="icon">
            <GridViewIcon />
          </IconButton>
          <Typography variant="h7">Hero Banner</Typography>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ backgroundColor: "#eceff1", padding: 4, borderRadius: 0 }}>
          <Typography
            variant="body1"
            sx={{ marginBottom: 3 }}
            style={{ fontSize: 17, fontFamily: "Inter", fontWeight: 500 }}
          >
            Banner orientation
          </Typography>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="banner-list" direction="horizontal">
              {(provided) => (
                <Box
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginBottom: 2,
                    flexWrap: "wrap",
                  }}
                >
                  {banners.length > 0 ? (
                    banners.map((image, index) => (
                      <Draggable
                        key={image.id}
                        draggableId={image.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <Box
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            sx={{ textAlign: "center" }}
                          >
                            <img
                              src={image.banner_image || previewImage}
                              alt={`Banner ${image.id}`}
                              style={{
                                width: "140px",
                                maxWidth: "140px",
                                height: "60px",
                                marginBottom: "10px",
                                marginTop: "10px",
                                filter:
                                  image.status === "enabled"
                                    ? "none"
                                    : "blur(3px)",
                                opacity: image.status === "enabled" ? 1 : 0.6,
                                transition: "filter 0.3s ease-in-out",
                              }}
                            />
                            {/*<Typography variant="body2">{image.title}</Typography>*/}
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <IconButton
                                sx={{ color: "grey", mr: 0.5 }}
                                onClick={() => handleEditImage(image)}
                              >
                                <EditOutlinedIcon />
                              </IconButton>
                              <IconButton
                                sx={{ mr: 0.5, color: "grey" }}
                                onClick={() =>
                                  handleVisibilityToggle(
                                    image.id,
                                    image.status !== "enabled"
                                  )
                                }
                              >
                                {image.status === "enabled" ? (
                                  <VisibilityOutlinedIcon />
                                ) : (
                                  <VisibilityOffOutlinedIcon />
                                )}
                              </IconButton>
                              <IconButton
                                sx={{ color: "red" }}
                                onClick={() => handleDeleteImage(image.id)}
                              >
                                <DeleteOutlinedIcon />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <Typography
                      style={{
                        fontSize: 12,
                        fontFamily: "Inter",
                        fontWeight: 500,
                      }}
                    >
                      No banners added yet.
                    </Typography>
                  )}
                  {provided.placeholder}
                </Box>
              )}
            </Droppable>
          </DragDropContext>
          <Box>
            <Typography
              variant="caption"
              style={{ fontSize: 12, fontFamily: "Inter", fontWeight: 500 }}
            >
              Shuffle images to define 1-5 sequence
            </Typography>
          </Box>
          {/*<IconButton variant='contained' sx={{ ...buttonStyle, mt: 2 }} onClick={handleAddNewBanner}><AddIcon /></IconButton>*/}
        </Box>
        {isFormVisible && (
          <Box
            sx={{
              padding: 4,
              pt: 2,
              display: "flex",
              flexDirection: "column",
              gap: 0,
              "@media (min-width: 600px)": { flexDirection: "column" },
              "@media (min-width: 960px)": { flexDirection: "column" },
            }}
          >
            <Divider sx={{ mt: 1, mb: 2 }} />
            <Typography
              variant="body1"
              sx={{
                color: "#424956",
                fontFamily: "Inter",
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              Name / Image Alt Text
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "35px",
                  borderRadius: "0px",
                  backgroundColor: "#fff",
                },
              }}
              value={formValues.image_alt_text}
              onChange={(e) =>
                handleFormChange("image_alt_text", e.target.value)
              }
            />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                sx={{ marginLeft: 0, marginRight: 2, alignItems: "center" }}
              >
                {formValues.banner_image || isEditing ? (
                  <figure>
                    <img
                      alt="Preview"
                      src={
                        formValues.banner_image ||
                        (isEditing ? editingImageUrl : null)
                      }
                      style={{
                        width: "100%",
                        maxWidth: "350px",
                        height: "150px",
                        border: "1px solid #ccc",
                        marginBottom: 2,
                      }}
                    />
                    <figcaption
                      style={{
                        fontSize: 14,
                        fontFamily: "Inter",
                        fontWeight: 500,
                      }}
                    >
                      W 1440px / H 300px
                    </figcaption>
                  </figure>
                ) : (
                  <Box
                    sx={{
                      width: "350px",
                      height: "150px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #ccc",
                    }}
                  >
                    <ImageIcon sx={{ fontSize: 60, color: "#ccc" }} />
                  </Box>
                )}
              </Typography>
              <IconButton component="label" sx={{ color: "black" }}>
                <FileUploadOutlinedIcon />
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(e) => handleImageUpload(e)}
                />
              </IconButton>
            </Box>
            <Typography
              variant="body1"
              sx={{
                color: "#424956",
                fontFamily: "Inter",
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              Title
            </Typography>
            <TextField
              fullWidth
              placeholder="Write title text here"
              variant="outlined"
              helperText="Max 20 characters including space"
              sx={{
                marginBottom: 1,
                "& .MuiOutlinedInput-root": {
                  height: "35px",
                  borderRadius: "0px",
                  backgroundColor: "#fff",
                },
              }}
              value={formValues.title}
              onChange={(e) => handleFormChange("title", e.target.value)}
            />
            <Typography
              variant="body1"
              sx={{
                color: "#424956",
                fontFamily: "Inter",
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              Subheading
            </Typography>
            <TextField
              fullWidth
              placeholder="Write text here"
              variant="outlined"
              helperText="Max 40 characters including space"
              sx={{
                marginBottom: 1,
                "& .MuiOutlinedInput-root": {
                  height: "35px",
                  borderRadius: "0px",
                  backgroundColor: "#fff",
                },
              }}
              value={formValues.subheading}
              onChange={(e) => handleFormChange("subheading", e.target.value)}
            />
            <Typography
              variant="body1"
              sx={{
                color: "#424956",
                fontFamily: "Inter",
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              CTA Text
            </Typography>
            <TextField
              fullWidth
              placeholder="Type your text here"
              variant="outlined"
              helperText="Max 10 characters including space"
              sx={{
                marginBottom: 1,
                "& .MuiOutlinedInput-root": {
                  height: "35px",
                  borderRadius: "0px",
                  backgroundColor: "#fff",
                },
              }}
              value={formValues.cta_text}
              onChange={(e) => handleFormChange("cta_text", e.target.value)}
            />
            {isEditing !== null && (
              <Box sx={{ display: "flex-col" }}>
                <Box sx={{ display: "flex-col" }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    Link collection page
                  </Typography>
                  <Autocomplete
                    fullWidth
                    options={[
                      {
                        label: "None",
                        value: "none",
                        collection_url: "",
                      },
                      ...collectionOptions,
                    ]}
                    getOptionLabel={(option) => option.label || ""}
                    value={
                      collectionOptions.find(
                        (option) =>
                          option.value === formValues.collection ||
                          option.label === formValues.collection_name
                      ) || {
                        label: formValues.collection_name || "None",
                        value: formValues.collection || "none",
                        collection_url: formValues.collection_url || "",
                      }
                    }
                    onChange={(event, newValue) => {
                      const updatedFormValues = { ...formValues };
                      if (newValue?.value === "none") {
                        updatedFormValues.collection = ""; // Clear the collection when "None" is selected
                        updatedFormValues.collection_url = ""; // Clear the URL
                        updatedFormValues.collection_name = ""; // Clear the collection name
                        updatedFormValues.link_page = ""; // Clear the link_page
                        updatedFormValues.isEditable = true; // Enable the text field
                      } else {
                        updatedFormValues.collection = newValue?.value || "";
                        updatedFormValues.collection_url = newValue?.collection_url || ""; // Update the URL to the selected collection's collection_url
                        updatedFormValues.collection_name = newValue?.label || ""; // Set the collection name
                        updatedFormValues.link_page = newValue?.collection_url || ""; // Set link_page to the selected collection's collection_url
                        updatedFormValues.isEditable = false; // Disable the text field
                      }
                      setFormValues(updatedFormValues);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        sx={{
                          marginBottom: 1,
                          "& .MuiInputBase-root": {
                            backgroundColor: "white",
                            height: "35px",
                            borderRadius: "0px",
                          },
                        }}
                      />
                    )}
                  />
                </Box>
                <Divider sx={{ margin: 0 }}> OR </Divider>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  URL to link collection page
                </Typography>
                <TextField
                  fullWidth
                  placeholder="URL"
                  variant="outlined"
                  sx={{
                    marginBottom: 1,
                    "& .MuiInputBase-root": {
                      backgroundColor: "white",
                      height: "35px",
                      borderRadius: "0px",
                    },
                  }}
                  value={formValues.link_page}
                  onChange={(e) => {
                    const updatedFormValues = { ...formValues };
                    updatedFormValues.link_page = e.target.value; // Update link_page value directly
                    setFormValues(updatedFormValues);
                  }}
                  disabled={!formValues.isEditable}
                />
              </Box>
            )}
            <Divider sx={{ marginBottom: 1, marginTop: 2 }} />
            <Button onClick={handleBannerSubmit} sx={{ ...buttonStyle, mt: 1 }}>
              Save
            </Button>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
